export const hasTruthyBooleanProperty = (propertyName: string) => (obj: object) =>
  Boolean(obj[propertyName]);

export const hasTruthyBooleanProperties = (propertyNames: string[]) => (obj: object) =>
  Boolean(propertyNames.every(prop => hasTruthyBooleanProperty(prop)(obj)));
